import React from "react";

const IconBell = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        role="img"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="M 14.227 13.801 C 14.058 12.968 14.121 10.793 14.99 8.218 C 15.512 6.672 15.398 4.981 14.673 3.519 C
        13.949 2.056 12.673 0.941 11.126 0.42 C 9.58 -0.102 7.889 0.012 6.427 0.737 C 4.964 1.461 3.849 2.737 3.328
        4.284 C 2.459 6.86 1.192 8.628 0.552 9.188 C 0.389 9.33 0.266 9.513 0.197 9.718 C 0.127 9.923 0.112 10.143
        0.154 10.355 C 0.196 10.567 0.294 10.765 0.436 10.927 C 0.579 11.09 0.762 11.212 0.967 11.281 L 3.942 12.285 C
        3.854 12.989 4.013 13.701 4.39 14.302 C 4.767 14.902 5.34 15.354 6.012 15.58 C 6.684 15.807 7.413 15.795 8.077
        15.545 C 8.741 15.296 9.298 14.825 9.655 14.212 L 12.63 15.216 C 12.835 15.284 13.055 15.298 13.267 15.255 C
        13.479 15.212 13.675 15.114 13.838 14.97 C 13.999 14.827 14.121 14.643 14.189 14.438 C 14.258 14.233 14.271
        14.013 14.227 13.801 Z M 6.405 14.415 C 6.043 14.293 5.729 14.062 5.504 13.753 C 5.279 13.445 5.155 13.074 5.15
        12.692 L 8.447 13.805 C 8.212 14.105 7.889 14.325 7.523 14.434 C 7.157 14.543 6.767 14.537 6.405 14.415 Z M
        1.361 10.115 C 2.247 9.339 3.607 7.307 4.494 4.677 C 4.911 3.44 5.803 2.419 6.973 1.84 C 8.143 1.26 9.495 1.169
        10.733 1.586 C 11.97 2.003 12.991 2.895 13.57 4.065 C 14.15 5.235 14.241 6.587 13.824 7.825 C 12.938 10.452
        12.787 12.892 13.023 14.049 L 1.361 10.115 Z" fill="currentColor"/>
    </svg>
);

export default IconBell;
